/**
 * Sequential time validation for the work ticket (v1 parity, commit fbbb3acb2:
 * "Ensure workticket dates are ordinal"). Times are full ISO datetimes — the
 * picker includes a date column, so overnight jobs compare correctly when the
 * operator picks the right day.
 */

/** True when `value` occurs strictly before `previous`. Equality is allowed. */
export const occursBefore = (
  value: string | null | undefined,
  previous: string | null | undefined,
): boolean => {
  if (!value || !previous) return false
  // NaN from an unparsable side makes the comparison false — no guard needed
  return new Date(value).getTime() < new Date(previous).getTime()
}

/**
 * react-hook-form `validate` rule: the field must not occur before the field
 * above it. `required` handles empty values, so those pass through. Takes
 * `unknown` because RHF types the value as the union of all form fields.
 */
export const timeAfterValidator =
  (getPrevious: () => string | null | undefined, message: string) =>
  (value: unknown): string | true =>
    occursBefore(typeof value === 'string' ? value : undefined, getPrevious())
      ? message
      : true
